module.exports = __webpack_public_path__ + "HRA Poster - First dollar.pdf";